import axios from 'axios';

const makeRequest = (method, url, data = {}, config = {}) => axios({
  method,
  url,
  data,
  ...config,
});

export default {
  async get(url, config = {}) {
    return makeRequest('get', url, {}, config);
  },
  async post(url, data = {}, config = {}) {
    return makeRequest('post', url, data, config);
  },
  async delete(url, data = {}, config = {}) {
    return makeRequest('delete', url, data, config);
  },
  async patch(url, data = {}, config = {}) {
    return makeRequest('patch', url, data, config);
  },
  async put(url, data = {}, config = {}) {
    return makeRequest('put', url, data, config);
  },
};
